import React from 'react';
import H2 from 'common/typography/H2/H2';
import i18n from '../../../../i18n/config';

export const lineColors = ['#333', '#e4e409'];

export const bhsLinks = {
  bearingsIntro: 'https://www.americanbearings.org/page/what_are_bearings',
  bearingsGuide: 'https://www.skf.com/binary/12-69177/457640.pdf',
  howBearingsWork: 'https://www.youtube.com/watch?v=Jt0ou8Q5Fo8',
  lubricationPractices: 'https://www.plantengineering.com/articles/best-practices-in-lubrication/',
  bearingTypes: 'https://www.nskamericas.com/en/services/what-s-a-bearing/types.html',
  bearingSelection: 'https://www.ntnglobal.com/en/products/catalog/pdf/2202E_a02.pdf',
  commonMistakes: 'https://www.efficientplantmag.com/2008/07/the-fundamentals-installation-errors-shorten-bearing-life/',
  spectrumAnalysis: 'http://www.vibrationschool.com/mans/SpecInter/SpecInter24.htm'
};

export const defaultMovingWindowSize = 10;

export const getRulCustomLabels = (t = i18n.t.bind(i18n)) => ({
  nonlinear_regression: t('machineDashboard.health.settings.rulMethods.nonlinearRegressionModel', {
    defaultValue: 'Nonlinear Regression Model'
  })
});

// Deprecated: prefer getRulCustomLabels(t).
export const rulCustomLabels = getRulCustomLabels();

export const rulMethodsToShow = [
  'trained_model'
];

export const getRulMethods = (t = i18n.t.bind(i18n)) => ([
  {
    text: t('machineDashboard.health.settings.rulMethods.trainedModel', { defaultValue: 'Trained Model' }),
    value: 'trained_model'
  },
  {
    text: t('machineDashboard.health.settings.rulMethods.nonlinearRegressionModel', { defaultValue: 'Nonlinear Regression Model' }),
    value: 'nonlinear_regression'
  }
]);

export const rulMethods = getRulMethods();

export const featureTypeOptionNames = {
  band_energies: 'band_energies',
  component_specific: 'component_specific'
};

export const getFeatureTypeOptions = (t = i18n.t.bind(i18n)) => ([
  {
    text: t('machineDashboard.health.settings.featureType.bandEnergyFeatures', { defaultValue: 'Band Energy Features' }),
    value: featureTypeOptionNames.band_energies
  },
  {
    text: t('machineDashboard.health.settings.featureType.componentSpecificFeatures', { defaultValue: 'Component Specific Features' }),
    value: featureTypeOptionNames.component_specific
  },
  { text: t('common.auto', { defaultValue: 'Auto' }), value: 'auto' }
]);

export const featureTypeOptions = getFeatureTypeOptions();

export const getValidationInfo = (t = i18n.t.bind(i18n), theme) => ({
  slope: (
    <span>
      <H2>{t('machineDashboard.health.settings.validationInfo.slope.heading')}</H2>
      {t('machineDashboard.health.settings.validationInfo.slope.description')}
      <br /><br />
      {t('machineDashboard.health.settings.validationInfo.common.acceptedValue')}{' '}
      <b style={{ color: theme.primaryColor }}>&lt; 0.0167 /day</b>
    </span>
  ),
  cv: (
    <span>
      <H2>{t('machineDashboard.health.settings.validationInfo.cv.heading')}</H2>
      {t('machineDashboard.health.settings.validationInfo.cv.description')}
      <br /><br />
      {t('machineDashboard.health.settings.validationInfo.cv.note')}
      <br /><br />
      {t('machineDashboard.health.settings.validationInfo.common.acceptedValue')}{' '}
      <b style={{ color: theme.primaryColor }}>&lt; 0.167</b>
    </span >
  ),
  outlier: (
    <span>
      <H2>{t('machineDashboard.health.settings.validationInfo.outlier.heading')}</H2>
      {t('machineDashboard.health.settings.validationInfo.outlier.description')}
      <br /><br />
      {t('machineDashboard.health.settings.validationInfo.outlier.accepted')}
    </span>
  )
});

// Deprecated: prefer getValidationInfo(t, theme).
export const validationInfo = theme => getValidationInfo(i18n.t.bind(i18n), theme);

export const getRulFeatures = (t = i18n.t.bind(i18n)) => ([
  { text: t('machineDashboard.health.settings.features.rmsAcceleration', { defaultValue: 'RMS Acceleration' }), value: 'rms_acceleration' },
  { text: t('machineDashboard.health.settings.features.rmsVelocity', { defaultValue: 'RMS Velocity' }), value: 'rms_velocity' }
]);

export const rulFeatures = getRulFeatures();
